import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL

export const invoicesService = {
  getAll,
  bill,
  downloadPdfOrXml
};

function getAll(page) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?sort=createdAt,DESC';

  parameters += '&page=' + page;

  return fetch(URL + "/users/invoices" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          id: resp.id,
          name: resp.attributes.name,
          status: resp.attributes.status,
          amount: resp.attributes.amount,
          created_at: resp.attributes.created_at
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function bill(taxDataId, invoiceId) {
  let formData = new FormData()
  formData.append("invoiceDataId", taxDataId);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/invoices/" + invoiceId, requestOptions).then(handleResponse);
}

function downloadPdfOrXml(invoiceId, type) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/users/invoices/" + invoiceId + "/" + type, requestOptions).then(resp => resp.blob())
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = 'Factura.' + type;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
